import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { MasterDefTag } from "../../pojo/MasterDefTag";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25SimpleCollapseComponent } from "../s25-simple-collapse/s25.simple.collapse.component";
import { S25ToggleButtonModule } from "../s25-toggle-button/s25.toggle.button.module";
import MasterDefI = MasterDefTag.MasterDefI;

@Component({
    selector: "s25-md-tag-item-collapse",
    template: `
        <s25-simple-collapse
            class="c-margin-bottom--single"
            [expanded]="false"
            [header]="masterDef.displayName + ' (' + (masterDef.active ? masterDef.items.length : 'Disabled') + ')'"
        >
            <div class="ngBlock c-margin-top--single c-objectDetails c-margin-left--single">
                <s25-toggle-button
                    [(value)]="masterDef.active"
                    (valueChange)="radioChange(masterDef, $event)"
                    [trueLabel]="'Enable'"
                    [falseLabel]="'Disable'"
                ></s25-toggle-button>
                @if (masterDef.active) {
                    <p class="ngFinePrint c-margin-bottom--half">
                        When enabled, users in assigned security group(s) will see the items on this tag and any other
                        tags their group has permissions to.
                    </p>
                }
                @if (!masterDef.active) {
                    <p class="ngFinePrint c-margin-bottom--half">
                        When disabled, this will have no impact in which users see these items.
                    </p>
                }

                <s25-ng-multiselect-search-criteria
                    [type]="masterDef.searchCriteriaName"
                    [selectedItems]="masterDef.items"
                    [modelBean]="masterDef.multiSelectModel"
                    honorMatching="true"
                    [popoverOnBody]="true"
                    [useSecurity]="false"
                ></s25-ng-multiselect-search-criteria>
            </div>
        </s25-simple-collapse>
    `,
    styles: `
        s25-simple-collapse {
            display: block;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [S25SimpleCollapseComponent, S25ToggleButtonModule, S25MultiselectModule],
})
export class S25MdTagItemCollapseComponent {
    @Input() masterDef: MasterDefI;
    @Output() masterDefChange: EventEmitter<MasterDefI> = new EventEmitter<MasterDefTag.MasterDefI>();

    radioChange(md: MasterDefI, event: boolean) {
        md.changed = true;
    }
}
